<app-call-waiter-indicator
  type="bill"
  class="bell"
  [class.active]="callWaiterRequestServer()"
/>

<span class="text">Request a Server</span>
@if (callWaiterRequestServer()) {
  <div class="info">
    Your server has been notified and will be right with you.<br/> <span>Tap to cancel.</span>
  </div>
} @else {
  <span class="action">Tap here</span>
}
